import cls from 'clsx';
import { Trans } from 'next-i18next';
import React from 'react';
import { NavLink } from '@/components/local/NavLink/NavLink';
import { ProductKeys } from '@/data/productsConfig';
import { getSpecialOfferTermsLink } from '@/utils/getSpecialOfferTermsLink';
import styles from './SpecialOfferFootnote.module.scss';

interface Props {
  classname?: string;
  i18nKey: string;
  productKey: ProductKeys;
}

export const SpecialOfferFootnote = ({
  classname,
  i18nKey,
  productKey,
}: Props) => (
  // TODO: check if the next issue is resolved,
  // so the Typography/Span can be used instead with the overwritten styles.
  // https://github.com/vercel/next.js/issues/64921
  <span className={cls(classname, styles.container)}>
    <Trans
      components={{
        navLink: (
          <NavLink
            target="_blank"
            id={styles.termAndConditionsLink}
            link={{
              type: 'local',
              ...getSpecialOfferTermsLink(productKey),
            }}
          >
            link
          </NavLink>
        ),
      }}
      i18nKey={i18nKey}
    />
  </span>
);
